import { z } from "zod";

export namespace BizUserRecentPositionsModels {
  /**
   * BizRecentPositionResponseDtoSchema
   * @type { object }
   * @property { string } id
   * @property { string } bizUserId
   * @property { string[] } recentPositions Array of recent position codes (e.g., ["11-3031", "13-2031"])
   * @property { string } createdAt
   * @property { string } updatedAt
   */
  export const BizRecentPositionResponseDtoSchema = z.object({
    id: z.string(),
    bizUserId: z.string(),
    recentPositions: z.array(z.string()),
    createdAt: z.string(),
    updatedAt: z.string(),
  });
  export type BizRecentPositionResponseDto = z.infer<typeof BizRecentPositionResponseDtoSchema>;

  /**
   * AddRecentPositionDtoSchema
   * @type { object }
   * @property { string } positionCode Position code to add to recent positions (e.g., "11-3031")
   */
  export const AddRecentPositionDtoSchema = z.object({ positionCode: z.string() });
  export type AddRecentPositionDto = z.infer<typeof AddRecentPositionDtoSchema>;
}
